function startCountdown(hours, minutes) {
    const duration = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000);

    function resetEndTime() {
        const newEndTime = Date.now() + duration;
        localStorage.setItem('countdownEndTime', newEndTime.toString());
        return newEndTime;
    }

    let endTime = localStorage.getItem('countdownEndTime');
    if (!endTime) {
        endTime = resetEndTime();
    } else {
        endTime = parseInt(endTime, 10);
        if (isNaN(endTime)) {
            endTime = resetEndTime();
        }
    }

    function updateCountdown() {
        const now = new Date().getTime();
        const distance = endTime - now;

        if (distance < 0) {
            endTime = resetEndTime();
            updateCountdown(); // Call again to update immediately
            return;
        }

        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        document.getElementById('hours').textContent = hours.toString().padStart(2, '0');
        document.getElementById('minutes').textContent = minutes.toString().padStart(2, '0');
        document.getElementById('seconds').textContent = seconds.toString().padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
}

document.addEventListener('DOMContentLoaded', () => {
    const hoursMeta = document.querySelector('meta[name="countdown-hours"]');
    const minutesMeta = document.querySelector('meta[name="countdown-minutes"]');
    const hours = parseInt(hoursMeta.getAttribute('content'), 10);
    const minutes = parseInt(minutesMeta.getAttribute('content'), 10);
    startCountdown(hours, minutes);
});
